
import React, {useState, forwardRef} from 'react';
//import React, { useEffect, useRef } from "react";


//import "./DatePicker.css";

// https://github.com/Hacker0x01/react-datepicker?tab=readme-ov-file
/* 
const XXDatePicker = (props) => {
  const [startDate, setStartDate] = useState( props.startDate ? props.startDate : new Date());
  registerLocale('de', de)
  
  const onChange = (date) => {
    setStartDate( date );
    props.onChange && props.onChange( date );
  }
 
  const CustomInput = forwardRef(
    ({ value, onClick, className }, ref) => (
      <button className={className} onClick={onClick} ref={ref}>
        {value}
      </button>
    ),
  );

  return <>
    <ReactDatePicker 
      selected={startDate}
      onChange={onChange}
      locale="de"
      dateFormat="dd.MM.yyyy"
      showIcon
      isClearable
      placeholderText="Geburtsdatum auswählen"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      />
  </>
};

shouldCloseOnSelect={false}
      customInput={<CustomInput className="btn btn-gm" />}      
*/


import { DatePicker as ReactDatePicker } from '@y0c/react-datepicker';
import * as dayjs from 'dayjs';
import 'dayjs/locale/de';

import './reactDatePickerStyle.scss';

const isTouchDevice = () =>
  typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;

const toInputValue = (date) => {
  const d = dayjs(date);
  return d.isValid() ? d.format('YYYY-MM-DD') : '';
};

const DatePicker = ({ startDate, onChange }) => {
  // const [mobile, setMobile] = useState(isTouchDevice);
  const [date, setDate] = useState(startDate || new Date());

  // useEffect(() => {
  //   const mq = window.matchMedia('(pointer: coarse)');
  //   const handler = (e) => setMobile(e.matches);
  //   mq.addEventListener('change', handler);
  //   return () => mq.removeEventListener('change', handler);
  // }, []);

  const handleNativeChange = (e) => {
    const newDate = e.target.value ? new Date(e.target.value) : null;
    setDate(newDate);
    onChange && onChange(newDate);
  };

  // const handlePickerChange = (dayjsDate) => {
  //   const newDate = dayjsDate.toDate();
  //   setDate(newDate);
  //   onChange && onChange(newDate);
  // };

  // if (mobile) {
    return (
      <input
        type="date"
        value={toInputValue(date)}
        onChange={handleNativeChange}
        style={{ fontSize: '16px' }}
      />
    );
  // }

  // return (
  //   <ReactDatePicker
  //     onChange={handlePickerChange}
  //     locale="de"
  //     initialDate={dayjs(date)}
  //     showDefaultIcon={true}
  //   />
  // );
};

export default DatePicker;
